import { Button, Form, Input, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { App } from 'antd';
import { getHttpErrorMessage } from 'utils/http';
import { captureException } from 'utils/errors';

function SendTextModal({ open, onClose, onSubmit, defaultToPhone }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { message } = App.useApp();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ to_phone: defaultToPhone || '' });
    }
  }, [open, defaultToPhone, form]);

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      const payload = {
        message: values.message?.trim() || '',
        to_phone: values.to_phone?.trim() || '',
      };
      onSubmit(payload)
        .then(() => {
          form.resetFields();
          handleClose();
        })
        .catch((e) => {
          captureException(e);
          message.error(getHttpErrorMessage(e) || 'Failed to send text');
        })
        .finally(() => setLoading(false));
    }).catch(() => {});
  };

  return (
    <Modal
      title="Send Text"
      open={open}
      onCancel={handleClose}
      footer={(
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="primary" loading={loading} onClick={handleSubmit}>
            Send
          </Button>
        </div>
      )}
      width={500}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="to_phone"
          label="To (phone number)"
          rules={[
            { required: true, message: 'Recipient phone number is required' },
          ]}
        >
          <Input placeholder="+1234567890" />
        </Form.Item>
        <Form.Item
          name="message"
          label="Message"
          rules={[
            { required: true, message: 'Message is required' },
          ]}
        >
          <Input.TextArea placeholder="Your message..." rows={6} autoSize={{ minRows: 6, maxRows: 12 }} maxLength={1600} showCount />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default SendTextModal;
